module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-2-de-DE-be0c534530aa742d7881bdbe34e24677.png";